<template>
	<div class="block" v-if="total">
		<el-pagination
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
			layout="total, prev, pager, next, jumper"
			:total="Number(total)"
			:page-size="Number(pagesize)"
		></el-pagination>
	</div>
</template>

<script>
	export default {
		name: "App",
		components: {},
		props: ["total", "pagesize"],
		methods: {
			handleSizeChange(size) {
				console.log(`每页 ${size} 条`);
			},
			handleCurrentChange(page) {
				this.$parent.getpagedata(page);
			}
		},
		data() {
			return {};
		}
	};
</script>

<style>
	/* 分页 */
	.block {
		display: flex;
		justify-content: center;
		margin-top: 40px;
		width: 100%;
	}

	.block /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #28a3b1 !important;
	}

	.block /deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover {
		color: #28a3b1;
	}
	.el-pager li.active {
		color: #28a3b1;
	}

	.el-pager li:hover {
		color: #28a3b1;
	}
	.el-pager li {
		background-color: #f5f5f5;
	}
	.btn-prev {
		background-color: #f5f5f5 !important;
	}
	.btn-next {
		background-color: #f5f5f5 !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/publicpaging.vue